import $ from 'jquery'
import Lightbox from 'lightbox2'

const opts = {
  lightOpts: {
    albumLabel: 'Immagine %1 di %2'
  }
}

const init = function() {

  Lightbox.option(opts.lightOpts)
}

$(document).ready(init)

export default { opts, init }






/** WEBPACK FOOTER **
 ** ./src/modules/lightbox2/index.js
 **/